// extracted by mini-css-extract-plugin
export default {"brandcard":"brandcard_brandcard__7nRmV","brandname":"brandcard_brandname__oZur6","brandimage":"brandcard_brandimage__DLlKE"};